import * as sdk from "microsoft-cognitiveservices-speech-sdk";

// Speech 服務配置
const SPEECH_CONFIG = {
    key: '21667b9wODATSCCYyrz9ftjDvtf9bUHOJRbV00lM6zEe14LvdBsAJQQJ99BAACxCCsyXJ3w3AAAYACOG1Sby',
    region: 'japaneast'
};

// 添加一個全局的 synthesizer 實例
let currentSynthesizer = null;

// Speech 服務工具類
export const speechService = {
    // 文字轉語音
    textToSpeech: async (text, language = 'zh-TW', onCompleted = null) => {
        try {
            // 如果有正在進行的播放，先停止它
            if (currentSynthesizer) {
                currentSynthesizer.close();
            }

            const config = sdk.SpeechConfig.fromSubscription(
                SPEECH_CONFIG.key,
                SPEECH_CONFIG.region
            );
            config.speechSynthesisLanguage = language;
            
            // 設置神經網絡語音
            let voiceName = 'zh-TW-HsiaoChenNeural';  // 台灣中文女聲
            if (language === 'en-US') {
                voiceName = 'en-US-JennyNeural';  // 英文女聲
            }
            config.speechSynthesisVoiceName = voiceName;

            // 創建 synthesizer，不指定音頻輸出
            const synthesizer = new sdk.SpeechSynthesizer(config, null);
            currentSynthesizer = synthesizer;

            // 創建 AudioContext
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            let audioSource = null;

            return new Promise((resolve, reject) => {
                synthesizer.speakTextAsync(
                    text,
                    result => {
                        if (result.reason === sdk.ResultReason.SynthesizingAudioCompleted) {
                            const audioData = result.audioData;
                            const arrayBuffer = new Uint8Array(audioData).buffer;
                            
                            audioContext.decodeAudioData(arrayBuffer, (decodedData) => {
                                audioSource = audioContext.createBufferSource();
                                audioSource.buffer = decodedData;
                                audioSource.connect(audioContext.destination);
                                
                                audioSource.onended = () => {
                                    // console.log('音頻播放結束');
                                    if (onCompleted && typeof onCompleted === 'function') {
                                        onCompleted();
                                    }
                                };

                                // console.log('音頻開始播放');
                                audioSource.start();
                            });
                            resolve({ result, completed: true });
                        } else {
                            reject(new Error(result.errorDetails));
                        }
                        synthesizer.close();
                        currentSynthesizer = null;
                    },
                    error => {
                        // console.error("語音合成錯誤: ", error);
                        synthesizer.close();
                        currentSynthesizer = null;
                        reject(error);
                    }
                );
            });
        } catch (error) {
            // console.error('文字轉語音失敗:', error);
            throw error;
        }
    },

    // 添加停止播放方法
    stopSpeaking: () => {
        if (currentSynthesizer) {
            currentSynthesizer.close();
            currentSynthesizer = null;
        }
    },

    // 語音轉文字
    speechToText: async (language = 'zh-TW') => {
        try {
            const config = sdk.SpeechConfig.fromSubscription(
                SPEECH_CONFIG.key,
                SPEECH_CONFIG.region
            );
            config.speechRecognitionLanguage = language;
            
            const audioConfig = sdk.AudioConfig.fromDefaultMicrophoneInput()
            const recognizer = new sdk.SpeechRecognizer(config, audioConfig)

            return new Promise((resolve, reject) => {
                recognizer.recognizeOnceAsync(
                    result => {
                        recognizer.close()
                        resolve(result.text)
                    },
                    error => {
                        recognizer.close()
                        reject(error)
                    }
                )
            })
        } catch (error) {
            // console.error('語音轉文字失敗:', error);
            throw error;
        }
    },

    // 停用遙測數據收集
    disableTelemetry: () => {
        sdk.Recognizer.enableTelemetry(false)
    }
}

// 錯誤處理
export const handleSpeechError = (error) => {
    console.error('Speech 服務錯誤:', error)
    return {
        error: '語音服務發生錯誤',
        details: error.message
    }
} 